import { z } from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"

const createMerchantGroupUserFormSchema = z.object({
  schemaName: z.string().min(1, "Field is required"),
  firstName: z
    .string()
    .min(1, "Field is required")
    .max(150),
  lastName: z.string().min(1, "Field is required").max(150),
  email: z
    .string()
    .email()
    .min(1, "Field is required")
    .max(150),
})

export const useCreateMerchantGroupUserForm = () =>
  useForm({
    validationSchema: toTypedSchema(
      createMerchantGroupUserFormSchema
    ),
  })
